import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { CriticalRisk, criticalRiskType } from "../../types/slices/criticalRiskType";

const initialState: criticalRiskType = {
    status: ApiStatus.FETCHED,
    criticalRisks: [],
    errorMessage: undefined,
    selectedCriticalRisk: {} as CriticalRisk,
};

const criticalRiskSlice = createSlice({
    name: "controlCriticalRisk",
    initialState,
    reducers: {
        onFetchCriticalRisk(state, { payload }: { payload: CriticalRisk[] }) {
            state.status = ApiStatus.FETCHED;
            state.criticalRisks = payload;
            state.errorMessage = undefined;
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload;
        },
        onSetSelectedCriticalRisk(state, { payload }: { payload: CriticalRisk }) {
            state.selectedCriticalRisk = payload;
        },
    }
})

export const selectCriticalRiskState = (state: RootState) => state.criticalRiskSlice;

export default criticalRiskSlice.reducer;

export const {
    onFetchCriticalRisk,
    changeStatus,
    onSetSelectedCriticalRisk,
} = criticalRiskSlice.actions;